// extracted by mini-css-extract-plugin
export var fileUpload = "_g8-1";
export var modalButton = "_g8-0";